import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { track } from '@amplitude/analytics-browser';
import { UserIcon } from '@nimbus-ds/icons';
import { CalloutCard } from '@nimbus-ds/patterns';
import { ROUTES } from 'App/Routes/constants';
import { useTranslationWithPrefix } from 'commons/utils';
import { PendingTrialPeriodAlertPage } from '../PendingTrialPeriodAlert';

interface InterfaceIdentityValidationCard {
  page: PendingTrialPeriodAlertPage;
}

function IdentityValidationCard({
  page,
}: InterfaceIdentityValidationCard): JSX.Element {
  const { push } = useHistory();
  const { t } = useTranslationWithPrefix(
    'configuration.identityValidationCard',
  );

  useEffect(() => {
    track('pago-nube-prueba-de-vida-old-view', {
      page,
    });
  }, [page]);

  const redirectToIdentityValidation = () => {
    track('pago-nube-prueba-de-vida-old-click', {
      page,
    });
    push(ROUTES.IDENTITY_VALIDATION_STEPS);
  };

  return (
    <CalloutCard
      appearance="warning"
      icon={UserIcon}
      title={t('title')}
      subtitle={t('subtitle')}
      onClick={redirectToIdentityValidation}
      data-testid="identity-validation-card"
    />
  );
}

export default IdentityValidationCard;
